import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import {
  LinkToAddTestCase,
  useSpaceAccess
} from '@eggplant/routing'
import { testCases } from '../../docs-routes'

const TestCases = () => {
  const [isAccess] = useSpaceAccess()

  return (
    <Paragraph>
      <Color
        display='inline'
        variant='theme-description-text'
      >
        {
          isAccess
            ? (
              <>
                Test Cases shows an overview of all the test cases you've configured.
                Here you can <LinkToAddTestCase>create a new test case</LinkToAddTestCase>,
                delete test cases, and export a list of your test cases in .csv format.
              </>
            )
            : 'Test Cases shows an overview of all the test cases you\'ve configured.'
        }
      </Color>
      <DocusaurusFooter path={testCases} />
    </Paragraph>
  )
}

export default TestCases
